"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntroSimple = void 0;

var react_1 = __importDefault(require("react"));

var elements_1 = require("../../elements");

var identity_1 = require("../../identity");

var base_1 = require("./base");

var IntroSimple = function IntroSimple(_a) {
  var title = _a.title,
      lead = _a.lead,
      _b = _a.hruler,
      hruler = _b === void 0 ? true : _b,
      cssStyle = _a.cssStyle,
      elementId = _a.elementId,
      _c = _a.paddingTop,
      paddingTop = _c === void 0 ? true : _c,
      _d = _a.paddingBottom,
      paddingBottom = _d === void 0 ? true : _d,
      _e = _a.marginTop,
      marginTop = _e === void 0 ? false : _e,
      _f = _a.marginBottom,
      marginBottom = _f === void 0 ? false : _f,
      _g = _a.theme,
      theme = _g === void 0 ? identity_1.ThemeLight : _g,
      _h = _a.centerContent,
      centerContent = _h === void 0 ? false : _h,
      _j = _a.containerContent,
      containerContent = _j === void 0 ? false : _j;
  return react_1["default"].createElement(base_1.IntroBase, {
    centerContent: centerContent,
    containerContent: containerContent,
    cssStyle: cssStyle,
    marginBottom: marginBottom,
    marginTop: marginTop,
    paddingBottom: paddingBottom,
    paddingTop: paddingTop,
    theme: theme,
    elementId: elementId
  }, react_1["default"].createElement(elements_1.Title, {
    theme: theme
  }, title), hruler && react_1["default"].createElement(elements_1.Hruler, {
    theme: theme
  }), lead && react_1["default"].createElement(elements_1.TextLead, {
    theme: theme,
    marginTop: hruler ? false : true
  }, lead));
};

exports.IntroSimple = IntroSimple;